/**
 * Created by iosc on 2018/1/15.
 */

import React, {PureComponent} from 'react'
import './About.css'

class About extends PureComponent {
	render() {
		return (
			<div>
				<img className="header" alt="introduction1" src={require('./images/points1.jpg')}/>
				<div className="header-s" alt="introduction1"
						 style={{backgroundImage: `url('${require('./images/points1.jpg')}')`}}/>
				<img alt="home3" id="normal" src={require('./images/points2.jpg')} style={{display: 'block', width: '100%'}}/>
				<img alt="home3" id='train' src={require('./images/points3.jpg')} style={{display: 'block', width: '100%'}}/>
			</div>
		)
	}
}

export default About


// WEBPACK FOOTER //
// ./src/Points.js